<script>
import { Line } from 'vue-chartjs'
import 'chartjs-plugin-datalabels'

import moment from 'moment'

export default {
	extends: Line,
	props  : {
		dataset: Array,
		unit   : String
	},
	data() {
		return {
			chartLabels: [],
			dataOptions: {
				borderColor    : '#4167c9',
				backgroundColor: 'rgba(65, 103, 201, 0.15)'
			},
			chartOptions: {
				responsive         : true,
				maintainAspectRatio: false,
				legend             : {
					display: false
				},
				layout: {
					padding: {
						top: 20
					}
				},
				scales: {
					yAxes: [{
						display: true,
						ticks  : {
							suggestedMin: 0,
							callback    : (value) => {
								if (value % 1 === 0) {
									return value
								}
							}
						}
					}]
				},
				plugins: {
					datalabels: {
						anchor         : 'center',
						align          : 'top',
						offset         : 2,
						color          : '#333',
						borderRadius   : 5,
						backgroundColor: 'rgba(255, 255, 255, .7)',
						font           : {
							size: 12
						},
						display: (context) => {
							const value = context.dataset.data[context.dataIndex]
							return value > 0 && context.dataset.data.length <= 31
						},
						formatter: (value, ctx) => {
							return value
						}
					}
				}
			}
		}
	},
	mounted() {
		this.renderTimeChart()
	},
	methods: {
		renderTimeChart() {
			this.renderChart({
				labels  : this.dataset.map(d => {
					try {
						const month = moment(d.label).format('MMM').toLowerCase()
						if (this.unit === 'week') {
							return this.$t('time.week_number', { week: moment(d.label).date() + ' ' + this.$t('time.month_short.' + month) })
						}

						if (this.unit === 'month') {
							return this.$t('time.month_short.' + month) + ' ' + moment(d.label).year()
						}
						return moment(d.label).date() + ' ' + this.$t('time.month_short.' + month)
					} catch (err) {
						return d.label
					}
				}),
				datasets: [
					Object.assign({}, this.dataOptions, {
						data: this.dataset.map(d => d.users)
					})
				]
			}, this.chartOptions)
		}
	},
	watch: {
		dataset() {
			this.renderTimeChart()
		}
	}
}
</script>
